import React, { Fragment } from 'react';
import { TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
 

const renderRadioField = ({ input, label, type, checked, className, id, onChanged: changeValue }) => {
    return (
    <Fragment>
        <input
            {...input}
            type={type} 
            className={className}
            id={id}
            checked={checked==input.value ? true : false}
            onChange={e => {
                const value = e.target.value
                input.onChange(); // call the onChange function passed to you by `Field` this will update pristine, dirty values. 
                if (changeValue) changeValue(value) // call your other side effect function
            }}
        />
    </Fragment>
  )};

renderRadioField.propTypes = {
    label: PropTypes.string,
    input: PropTypes.object,
    meta: PropTypes.object,
};

export default renderRadioField;
